export default __webpack_public_path__ + "static/media/Lipika Agasti.0ef9e31c.JPG";